import { Paper } from "@mui/material";
import React, { Component } from 'react';
import FollowUpRutin from "./FollowUpRutin";

class FollowupRutinWrapper extends Component {
    state = {  } 
    render() { 
        return (
            <>
                <FollowUpRutin {...this.props} fuType={2} />
                <br />
                <FollowUpRutin {...this.props} fuType={3} />
                <br />
                <FollowUpRutin {...this.props} fuType={4} />
            </>        
        );
    }
}
 
export default FollowupRutinWrapper;